class HttpMethod {
    static DELETE = 'DELETE';
    static GET = 'GET';
    static HEAD = 'HEAD';
    static OPTIONS = 'OPTIONS';
    static PATCH = 'PATCH';
    static POST = 'POST';
    static PUT = 'PUT';
    static TRACE = 'TRACE';
}

export default HttpMethod;


// WEBPACK FOOTER //
// ./src/_utils/HttpMethod.js